<template>
  <div class="Visualisation"> 
    <div ref="container" class="Visualisation__container">
      <canvas :id="indice"/>

      <!-- 
      <template v-if="ready && indice == 'visualisation'">
        <Ring v-for="(ring, i) in $rings" ref="ring" :specs="ring" :key="i"/>
      </template>

      <template v-if="ready && indice == 'hear'">
        <SingleLine  v-for="(line, i) in $lines" ref="line" :specs="line" :key="i" />
      </template>
      -->

      <template v-if="ready">
        <Ring v-for="(ring, i) in $rings" ref="ring" :specs="ring" :key="i"/>
      </template>

      <RecorderComp v-if="indice == 'visualisation'"/>
      <PlayerComp v-if="indice == 'hear' && used == true"/>

    </div>
  </div> 
</template>

<script>

import gsap from "gsap"
import SimplexNoise from "simplex-noise"
// import { BUBBLE_VERTEX_SHADER, BUBBLE_FRAGMENT_SHADER } from "../js/constant.js"
import { Color, Vector3 } from "three"
import Ring from "./Ring.vue"
import SingleLine from "./SingleLine.vue"
import RecorderComp from "./RecorderComp.vue"
import PlayerComp from "./PlayerComp.vue"

export default {

  name: 'Visualisation',
  props: ['indice'],
  components: { Ring, RecorderComp, PlayerComp, SingleLine },
  data: ()=>({
    ready: false,
    analyser: 0,
    intensity: 0,
    anw: 0,
    used: true
  }),

  computed: {
    status() { return this.$store.getters['app/status'] }
  },

  watch: {

    status(nw) {
      if(nw == 'stop_recording' 
      || nw == 'audio_ended')
        this.intensity = 0
    },

    'analyser'(nw, od) {

      if(od) {

        this.anw = (Math.abs(nw-od)*7.5)
        let tmp = this.intensity

        if(this.anw > 0.1) tmp += .25
        else tmp -= .5
        
        if(tmp > 4) tmp = 4
        else if(tmp < 0) tmp = 0

        this.intensity = tmp

      }
    },

  },

  mounted() {

    console.log(this.indice);

    this.$rings = [
      { size : 12.00, c1: 'fuchsia', c2: 'darkgreen' },
      { size : 11.75, c1: 'deeppink', c2: 'deepskyblue'  },
      { size : 11.50, c1: 'orangered', c2: 'orange'  },
      { size : 11.25, c1: 'yellow', c2: 'green'  },
      { size : 11.00, c1: 'gold', c2: 'green'  },
    ]

    this.$lines = [
      { color: 0x3211BD, pos: 0 },
      { color: 0x008D0C, pos: 1 },
      { color: 0xDB2100, pos: 2 },
      { color: 0xEFE200, pos: 3 },
      // { color: 0x009DC7, pos: -1.5 },
      // { color: 0xFF7700, pos: 1.5 },
    ]

    this.init()
  },

  methods: {

    stopAudio() {

      console.log('stopAudio');

      gsap.to(this, { intensity: 0, ease: 'none', duration: .25 })

      this.used = false
      // this.intensity = 0
    },

    init() {

      // const simplex = new SimplexNoise()

      const canvas = document.getElementById( ""+ this.indice + "" )
      const bounds = this.$refs.container.getBoundingClientRect()

      // console.log(canvas);
      // console.log(bounds);

      let scene = new THREE.Scene()
      let camera = new THREE.PerspectiveCamera( 75, bounds.width / bounds.height, 0.1, 50 )
          camera.position.z = 25
          camera.position.y = 3

      let renderer = new THREE.WebGLRenderer( { antialias: true, canvas: canvas, alpha: true } )
          renderer.setPixelRatio( window.devicePixelRatio )
          renderer.setSize( bounds.width, bounds.height )
          renderer.setClearColor( 0xdb2000, 0)

      let ambientLight = new THREE.AmbientLight( 0x000000 )
            scene.add( ambientLight )

      let render = ()=> {
        requestAnimationFrame( render )
        const time = performance.now() * 0.00005 * 15 * Math.pow(1, 3)
        const spikes = .5 * 1
        if(this.ready){

          // if(this.indice == 'visualisation')
          //   _.each(this.$refs.ring, (ring)=>{
          //     ring.update(performance.now()*.0025, spikes, this.anw, this.intensity)
          //   })
          // else if(this.indice == 'hear')
          //   _.each(this.$refs.line, (line)=>{
          //     line.update(performance.now()*.0025, spikes, this.anw, this.intensity)
          //   })

          _.each(this.$refs.ring, (ring)=>{
            ring.update(performance.now()*.0025, spikes, this.anw, this.intensity)
          })
        }
        renderer.render( scene, camera )
      }

      this.$nextTick(()=>{
        this.scene = scene
        this.ready = true
        render()
      })  
    },
   
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Visualisation
  
  width 100%
  height 45%
  position relative
  display flex 
  align-items center
  justify-content center
  position absolute
  top 22%

  &__container 
    position relative
    width 100%
    height 100%
    display flex 
    align-items center
    justify-content center

  & img
    // height 100%
    // width 80% !important
    // height 43%
    width 300px !important
    height 300px

#hear
#visualisation
  height 100%
  background transparent
  border none

</style>


